<!-- @format -->

@if (ready) {
  <div aria-labelledby="student-profile-study-rights-tab" id="study-rights" role="tabpanel" tabindex="0" class="sis-pt-md">
    <div class="d-sm-flex justify-content-sm-between">
      <h2>{{ "PROFILE.STUDY_RIGHTS" | translate }}</h2>
      <sis-button
        [size]="'sm'"
        [hollow]="true"
        [variant]="'secondary'"
        (clicked)="openCreateStudyCertificateModal()"
        class="sis-mb-sm d-block">
        {{ "PROFILE.CREATE_STUDY_CERTIFICATE" | translate }}
      </sis-button>
    </div>
    <h3>{{ "STUDY_RIGHTS.HEADINGS.DEGREE_RIGHTS" | translate }}</h3>
    @if (degreeStudyRights?.length > 0) {
      @for (degreeStudyRight of degreeStudyRights; track degreeStudyRight) {
        <ng-template [ngTemplateOutlet]="studyRightExpandable" [ngTemplateOutletContext]="{ studyRight: degreeStudyRight }"></ng-template>
      }
    } @else {
      <p class="sis-guidance">{{ "STUDY_RIGHTS.NO_STUDY_RIGHTS" | translate }}</p>
    }
    <h3>{{ "STUDY_RIGHTS.HEADINGS.OPEN_UNIVERSITY_RIGHTS" | translate }}</h3>
    @if (openUniversityStudyRights?.length > 0 || oldOpenUniversityStudyRights?.length > 0) {
      @for (openUniversityStudyRight of openUniversityStudyRights; track openUniversityStudyRight) {
        <app-enrolment-right-student-study-right [studyRight]="openUniversityStudyRight"> </app-enrolment-right-student-study-right>
      }
      @for (oldOpenUniversityStudyRight of oldOpenUniversityStudyRights; track oldOpenUniversityStudyRight) {
        <ng-template
          [ngTemplateOutlet]="studyRightExpandable"
          [ngTemplateOutletContext]="{ studyRight: oldOpenUniversityStudyRight }"></ng-template>
      }
    } @else {
      <p class="sis-guidance">{{ "STUDY_RIGHTS.NO_STUDY_RIGHTS" | translate }}</p>
    }
    <h3>{{ "STUDY_RIGHTS.HEADINGS.OTHER_RIGHTS" | translate }}</h3>
    @if (otherStudyRights?.length > 0 || otherBasedOnEnrolmentRightStudyRights?.length > 0) {
      @for (otherStudyRight of otherStudyRights; track otherStudyRight) {
        <ng-template [ngTemplateOutlet]="studyRightExpandable" [ngTemplateOutletContext]="{ studyRight: otherStudyRight }"></ng-template>
      }
      @for (otherBasedOnEnrolmentRightStudyRight of otherBasedOnEnrolmentRightStudyRights; track otherBasedOnEnrolmentRightStudyRight) {
        <app-enrolment-right-student-study-right [studyRight]="otherBasedOnEnrolmentRightStudyRight">
        </app-enrolment-right-student-study-right>
      }
    } @else {
      <p class="sis-guidance">{{ "STUDY_RIGHTS.NO_STUDY_RIGHTS" | translate }}</p>
    }
  </div>
}

<ng-template #studyRightExpandable let-studyRight="studyRight">
  @if (studyRight.id | studyRightName | async | localizedString; as srName) {
    <sis-expandable
      data-cy="study-right-profile-element"
      [level]="4"
      [closed]="studyRight.id !== this.selectedStudyRightId"
      [title]="srName">
      <ng-template sisExpandableCustomTitle>
        <sis-study-right-status-badge [studyRightId]="studyRight.id" />
      </ng-template>
      <ng-template sisExpandableHeaderButtons>
        @if (
          studyRightExtensionApplicationEnabledByUniversity &&
          studyRightExpirations[studyRight.id] &&
          !studyRightExpirations[studyRight.id]?.pendingExtensionApplication
        ) {
          <sis-button size="sm" (clicked)="initStudyRightExtensionApplication(studyRight)">
            {{ "STUDY_RIGHT_EXPIRATION.EXTENSION_APPLY" | translate }}
          </sis-button>
        }
        @if (studyRightExpirations[studyRight.id]?.pendingExtensionApplication) {
          <sis-button size="sm" (clicked)="openStudyRightExtensionApplication(studyRight.id)">
            {{ "STUDY_RIGHT_EXPIRATION.EXTENSION_SHOW_APPLICATION" | translate }}
          </sis-button>
        }
      </ng-template>
      <ng-template sisExpandableContent>
        @if (studyRightExpirations[studyRight.id]; as studyRightExpiration) {
          <div class="sis-pb-md">
            <sis-contextual-notification variant="warning">
              {{
                "STUDY_RIGHT_EXPIRATION." + (studyRightExpiration.isExpired ? "EXPIRED_INFO" : "EXPIRING_INFO")
                  | translate: { endDate: (studyRightExpiration.inclusiveEndDate | localDateFormat) }
              }}
              {{ "STUDY_RIGHT_EXPIRATION.EXTENSION_INFO_" + (studyRightExpiration.isExpired ? "EXPIRED" : "EXPIRING") | translate }}
            </sis-contextual-notification>
          </div>
        }
        <sis-read-only-study-right [studyRight]="studyRight" [selectedStudyRightId]="this.selectedStudyRightId" />
      </ng-template>
    </sis-expandable>
  }
</ng-template>
